// extracted by mini-css-extract-plugin
module.exports = {"mobileSize":"900","wrapper":"NumberList-module--wrapper--3Yu2q"};